<template>
    <v-container v-if="!isLoading" fluid>
        <v-row>
            <v-col class="d-flex align-center justify-center">
                <div class="message-container">
                    <h2 v-if="$store.state.messageHeadline">{{$store.state.messageHeadline}}</h2>
                    <span v-html="$store.state.messageContent"></span>
                </div>
            </v-col>
        </v-row>
        <v-row v-if="isClosedTime() || isPreOpenTime() || isSpecialEvent() || isPatientMaxLimitExceeded">
            <v-col class="text-center">
                <v-btn large color="secondary" @click="backToLobby" raised style="font-size: 18px; font-weight: 700;">Back to home</v-btn>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import ContextualMixin from '../mixins/contextualMixin'

    export default {
        name: 'Message',
        mixins: [ContextualMixin],
        mounted() {
            this.$store.state.currentStep = 0;
            if (!this.$store.state.messageHeadline && !this.$store.state.messageContent)
                this.backToLobby();
        },
        computed: {
            isPatientMaxLimitExceeded() {
                return this.$store.state.isPatientMaxLimitExceeded;
            },
            messageType() {
                return this.isClosedTime() || this.isPreOpenTime() ? 'info' : 'error';
            },
            messageColor() {
                return this.messageType == 'info' ? 'primary' : 'red darken-2';
            }
        }
    }
</script>

<style>
    .message-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-top: 20px;
        margin-bottom: 20px;
    }

    .message-container > h2 {
        font-size: 24px;
        font-weight: 800;
        margin-bottom: 15px;
    }

    .message-container > span {
        font-size: 18px;
        font-weight: 600;
    }
</style>